import React, { useRef, useEffect } from 'react';

export function AudioControls({ audioTracks, volumes, onVolumeChange }) {
  return (
    <div className="panel audio-controls">
      <h2>Audio ({audioTracks.length})</h2>
      <div className="audio-track-list">
        {audioTracks.map(([id, { track, publication, participant }]) => (
          <AudioTrack
            key={id}
            id={id}
            track={track}
            publication={publication}
            participant={participant}
            volume={volumes.get(id) ?? 100}
            onVolumeChange={onVolumeChange}
          />
        ))}
      </div>
    </div>
  );
}

function AudioTrack({ id, track, publication, participant, volume, onVolumeChange }) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!track || !audioRef.current) return;

    // Attach track to audio element
    track.attach(audioRef.current);

    return () => {
      track.detach(audioRef.current);
    };
  }, [track]);

  // Apply volume changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume / 100;
    }
  }, [volume]);

  const handleVolumeChange = (e) => {
    onVolumeChange(id, parseInt(e.target.value, 10));
  };

  const participantName = participant?.identity || 'Unknown';
  const source = publication?.source || 'unknown';
  const isScreenAudio = source === 'screen_share_audio';

  return (
    <div className="audio-track">
      <audio ref={audioRef} autoPlay />
      <div className="audio-track-header">
        <span className="audio-track-name">{participantName}</span>
        <span className="audio-track-type">
          {isScreenAudio ? 'Screen Audio' : 'Microphone'}
        </span>
      </div>
      <div className="volume-control">
        <button
          className="btn-icon"
          onClick={() => onVolumeChange(id, volume === 0 ? 100 : 0)}
          title={volume === 0 ? 'Unmute' : 'Mute'}
        >
          {volume === 0 ? 'Muted' : 'Vol'}
        </button>
        <input
          type="range"
          min="0"
          max="100"
          value={volume}
          onChange={handleVolumeChange}
        />
        <span className="volume-value">{volume}%</span>
      </div>
    </div>
  );
}
